(function () {
  if (window.AtelierCoconMerchandising) return;

  const EVENT_PREFIX = 'atelier_cocon_merchandising';

  function rootPath() {
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const themeRoot = window.routes && window.routes.root;
    const root = shopifyRoot || themeRoot || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function pushEvent(name, detail) {
    const payload = Object.assign({ event: `${EVENT_PREFIX}_${name}` }, detail || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('atelier-cocon:merchandising', { detail: payload }));
  }

  function bindTracking(scope) {
    scope.querySelectorAll('[data-ac-merch-track]:not([data-ac-merch-bound])').forEach((element) => {
      element.dataset.acMerchBound = 'true';
      element.addEventListener('click', () => {
        pushEvent(element.dataset.acMerchTrack, {
          merchandising_surface: element.dataset.acMerchSurface || '',
          merchandising_source: element.dataset.acMerchSource || '',
          merchandising_target: element.dataset.acMerchTarget || ''
        });
      });
    });
  }

  function readCartItems(element) {
    const script = element.querySelector('[data-ac-cart-items]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function scoreCartItem(item) {
    const handle = item.product_handle || '';

    if (handle.includes('bundle-futon') || handle.includes('cocon')) return 1;
    if (handle.includes('futon')) return 2;
    if (handle.includes('ensemble-de-meditation') || handle.includes('assise')) return 3;
    if (handle.includes('zafu') || handle.includes('demi')) return 4;
    if (handle.includes('bolster') || handle.includes('restauratif')) return 5;
    if (handle.includes('lavande') || handle.includes('eye') || handle.includes('yeux')) return 6;
    if (handle.includes('tour') || handle.includes('cou') || handle.includes('nuque')) return 7;

    return 20;
  }

  function cartHasBundle(cartHandles, keywords) {
    return cartHandles.some((handle) => keywords.some((keyword) => handle.includes(keyword)));
  }

  function hasBlockedBundleComponent(candidateHandle, cartHandles) {
    const componentGroups = [
      {
        bundle: ['bundle-futon', 'cocon'],
        components: ['futon', 'bolster', 'zafu', 'demi', 'lavande', 'eye', 'yeux']
      },
      {
        bundle: ['restauratif', 'yin'],
        components: ['bolster', 'zafu', 'demi', 'lavande', 'eye', 'yeux']
      },
      {
        bundle: ['ensemble-de-meditation', 'assise'],
        components: ['zafu', 'demi', 'zabuton']
      },
      {
        bundle: ['rituel-de-detente', 'rituel-detente'],
        components: ['tour', 'cou', 'nuque', 'lavande', 'eye', 'yeux']
      }
    ];

    return componentGroups.some((group) => {
      if (!cartHasBundle(cartHandles, group.bundle)) return false;
      return group.components.some((keyword) => candidateHandle.includes(keyword));
    });
  }

  function bestVariant(product) {
    const variants = product && Array.isArray(product.variants) ? product.variants : [];
    return variants.find((variant) => variant.available) || variants[0] || null;
  }

  function imageUrl(product) {
    if (!product) return '';
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (Array.isArray(product.images) && product.images.length) {
      const firstImage = product.images[0];
      return typeof firstImage === 'string' ? firstImage : firstImage.url || '';
    }
    return '';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.money_format);
    }

    return `${(cents / 100).toFixed(2)}`;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function contextualTitle(sourceHandle, candidateHandle, defaults) {
    if (sourceHandle.includes('bundle-futon') || sourceHandle.includes('cocon')) {
      return defaults.bundleTitle || "Les détails qui font l'espace";
    }

    if (sourceHandle.includes('futon') && candidateHandle.includes('bolster')) {
      return defaults.supportTitle || 'Ajoutez du soutien';
    }

    if (
      sourceHandle.includes('lavande') ||
      sourceHandle.includes('eye') ||
      sourceHandle.includes('yeux') ||
      sourceHandle.includes('tour') ||
      sourceHandle.includes('cou') ||
      sourceHandle.includes('nuque')
    ) {
      return defaults.ritualTitle || 'Prolonger le rituel';
    }

    return defaults.defaultTitle || 'La touche finale';
  }

  async function fetchRecommendations(productId) {
    const url = `${rootPath()}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=4&intent=complementary`;
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return [];

    const data = await response.json();
    return data && Array.isArray(data.products) ? data.products : [];
  }

  async function findCartRecommendation(items) {
    const cartHandles = items.map((item) => item.product_handle || '');
    const cartHandleSet = new Set(cartHandles);
    const cartProductIds = new Set(items.map((item) => String(item.product_id)));
    const prioritizedItems = items.slice().sort((a, b) => scoreCartItem(a) - scoreCartItem(b));

    for (const sourceItem of prioritizedItems) {
      const recommendations = await fetchRecommendations(sourceItem.product_id);

      for (const product of recommendations) {
        const candidateHandle = product.handle || '';
        const variant = bestVariant(product);

        if (!candidateHandle || !variant) continue;
        if (cartHandleSet.has(candidateHandle)) continue;
        if (cartProductIds.has(String(product.id))) continue;
        if (hasBlockedBundleComponent(candidateHandle, cartHandles)) continue;

        return { product, variant, sourceItem };
      }
    }

    return null;
  }

  function renderCartRecommendation(element, recommendation) {
    const content = element.querySelector('[data-ac-cart-content]');
    if (!content) return;

    const product = recommendation.product;
    const variant = recommendation.variant;
    const sourceHandle = recommendation.sourceItem.product_handle || '';
    const candidateHandle = product.handle || '';
    const defaults = {
      defaultTitle: element.dataset.defaultTitle,
      supportTitle: element.dataset.supportTitle,
      ritualTitle: element.dataset.ritualTitle,
      bundleTitle: element.dataset.bundleTitle
    };
    const title = contextualTitle(sourceHandle, candidateHandle, defaults);
    const image = imageUrl(product);
    const price = typeof product.price === 'number' ? product.price : variant.price;
    const url = product.url || `${rootPath()}products/${candidateHandle}`;

    content.innerHTML = `
      <div class="atelier-cocon-cart__inner">
        <span class="atelier-cocon-cart__eyebrow">${escapeHtml(title)}</span>
        <a class="atelier-cocon-cart__product" href="${escapeHtml(url)}" data-ac-merch-track="click" data-ac-merch-surface="cart_drawer" data-ac-merch-source="${escapeHtml(sourceHandle)}" data-ac-merch-target="${escapeHtml(candidateHandle)}">
          <span class="atelier-cocon-cart__media">${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}</span>
          <span class="atelier-cocon-cart__meta">
            <span class="atelier-cocon-cart__product-title">${escapeHtml(product.title)}</span>
            <span class="atelier-cocon-cart__price">${formatMoney(price)}</span>
          </span>
        </a>
        <button type="button" class="button button-2 atelier-cocon-cart__add" data-ac-cart-add data-variant-id="${escapeHtml(variant.id)}" data-ac-merch-track="add" data-ac-merch-surface="cart_drawer" data-ac-merch-source="${escapeHtml(sourceHandle)}" data-ac-merch-target="${escapeHtml(candidateHandle)}">
          ${escapeHtml(element.dataset.addText || '+ Ajouter')}
        </button>
      </div>
    `;

    element.classList.add('is-visible');
    content.hidden = false;
    bindTracking(content);
  }

  async function initCartRecommendation(element) {
    if (element.dataset.acCartLoading === 'true') return;

    const content = element.querySelector('[data-ac-cart-content]');
    const items = readCartItems(element);

    element.classList.remove('is-visible');
    if (content) {
      content.hidden = true;
      content.innerHTML = '';
    }

    if (!items.length) return;

    element.dataset.acCartLoading = 'true';

    try {
      const recommendation = await findCartRecommendation(items);
      if (recommendation) renderCartRecommendation(element, recommendation);
    } catch (error) {
      element.classList.remove('is-visible');
    } finally {
      element.dataset.acCartLoading = 'false';
    }
  }

  function initCartRecommendations(scope) {
    scope.querySelectorAll('[data-ac-cart-cross-sell]').forEach(initCartRecommendation);
  }

  async function handleCartAdd(event) {
    const button = event.target.closest('[data-ac-cart-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = button.dataset.loadingText || 'Ajout...';

    try {
      const response = await fetch(`${rootPath()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties: {
            _merchandising: 'atelier-cocon-cart-cross-sell'
          }
        })
      });

      if (!response.ok) throw new Error('Unable to add product');

      pushEvent('add_to_cart', {
        merchandising_surface: button.dataset.acMerchSurface || 'cart_drawer',
        merchandising_source: button.dataset.acMerchSource || '',
        merchandising_target: button.dataset.acMerchTarget || ''
      });

      if (window.Shopify && typeof window.Shopify.getCart === 'function' && window.halo && typeof window.halo.updateSidebarCart === 'function') {
        window.Shopify.getCart((cart) => window.halo.updateSidebarCart(cart));
      } else {
        document.dispatchEvent(new CustomEvent('cart-update'));
      }
    } catch (error) {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = originalText;
    }
  }

  function init(scope) {
    const root = scope || document;
    bindTracking(root);
    initCartRecommendations(root);
  }

  document.addEventListener('click', handleCartAdd);
  document.addEventListener('cart-update', () => window.setTimeout(() => init(document), 0));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  window.AtelierCoconMerchandising = { init };
})();
